const styles = (theme) => ({
  // Full width in Customer Management (Settings holiday layout uses a narrower side panel).
  moduleContainer: {
    padding: 0,
    paddingTop: 16
  },
  gridContainer: {
    maxWidth: '100%',
    width: '100%',
    padding: 0
  },
  holidayGridContainer: {
    maxWidth: '100%',
    padding: 0,
    '& $gridHead': {
      minHeight: 32,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    '& $dataGrid': {
      height: '32%',
      border: 'unset'
    }
  },
  holidayGrid: {
    margin: '6px 0 60px 0',
    [`&>.gridTheme-${theme.themeName}`]: {
      height: 'unset',
      border: `1px solid ${theme.AppBGColor}`
    },
    '& .ag-theme-material': {
      borderBottom: `1px solid ${theme.AppBGColor}`
    },
    // Override Settings shared dataGrid viewport hack so horizontal scroll can appear.
    '& .ag-center-cols-viewport': {
      width: '100%'
    }
  },
  // Replace Settings dataGrid viewport rule for this dialog grid.
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: 'unset',
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%'
    },
    '& .statusBar': {
      display: 'none'
    },
    '& .ag-center-cols-viewport': {
      width: '100%'
    }
  },
  gridHead: {
    padding: '5px 0',
    minHeight: 32,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 4
  },
  actionButton: {
    textTransform: 'none',
    minWidth: 170
  },
  actionContainer: {
    padding: 0
  },
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: '0px 0px 4px 4px',
    width: '170px'
  },
  menuItem: {
    padding: '6px 0px',
    '&:hover': {
      background: theme.customMultiSelectColor
    }
  },
  customPopper: {
    zIndex: 1400,
    marginTop: 0
  },
  headerMenuIconStyles: {
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  iconLabel: {
    fontSize: theme.headerTextFontSize
  },
  iconLayout: {
    color: theme.iconColor,
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'center'
  },
  // Keep separator height aligned to the Add Holiday button (not the full header row).
  headerIconStyles: {
    padding: '0 0 0 10px',
    marginLeft: 4,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: 'fit-content'
  }
});

export default styles;
